<template>
  <div id="operationsContainer" v-uploader="dropFileHandler">
    <div style="float: left">
      <el-button v-if="addMydoc" class="btnBgColor" size="small" type="primary" @click="addFolder"> <i class="el-icon-plus"></i> 新建文件夹 </el-button>
      <el-dropdown v-if="uploadMydoc" trigger="click" class="btnBgColor" placement="bottom-start" @command="isFileOrFolder">
        <el-button size="small" type="primary" plain> <i class="el-icon-upload2"></i> 上传 </el-button>

        <el-dropdown-menu slot="dropdown" style="width: 94px">
          <el-dropdown-item command="file" style="text-align: center !important"> 文件 </el-dropdown-item>
          <el-dropdown-item command="folder" style="text-align: center !important"> 文件夹 </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="moveMydoc" size="small" type="primary" plain @click="moveFile('移动到')"> <i class="el-icon-rank"></i> 移动到 </el-button>
      <el-button v-if="copyMydoc" size="small" type="primary" plain @click="copyFile('复制到')"> <i class="el-icon-document-copy"></i> 复制到 </el-button>
      <el-button v-if="downMydoc" size="small" type="primary" plain @click="batchDownload"> <i class="el-icon-download"></i> 下载 </el-button>
      <el-button v-if="shareMydoc" size="small" type="primary" plain @click="batchShare">
        <i class="el-icon-share"></i>
        分享
      </el-button>
      <el-button v-if="deleMydoc" size="small" type="danger" plain @click="batchDel"> <i class="el-icon-delete"></i> 删除 </el-button>
    </div>
    <div class="search" style="margin-left: auto">
      <el-input
        v-model.trim="searchValue"
        type="text"
        style="height: 100%; cursor: pointer"
        size="small"
        :placeholder="searchTiTle"
        :suffix-icon="!searchValue ? 'el-icon-search' : ''"
        :clearable="Boolean(searchValue)"
        maxlength="20"
      >
      </el-input>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
export default {
  directives: { uploader: uploader.directive() },
  data() {
    return {
      searchValue: "",
      addMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_ADD),
      moveMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_MOVE),
      copyMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_COPY),
      downMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_DOWN),
      shareMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_SHARE),
      deleMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_DELE),
      uploadMydoc: checkPermission(this.$allPerms.PUBLICINFORMATION_UPLOAD),
      val: ""
    };
  },
  computed: {
    ...mapState({
      currentNode: (state) => state.perFile.currentTreeNodeFen,
      selectArr: (state) => state.XtDesign.selectArr, // 勾选的文件
      perFileMoveAndCopy: (state) => state.perFile.moveAndCopy,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    uploaderOpts() {
      const data = this.currentNode;
      const { folderId } = data;
      const params = {
        prjId: "EnterpriseDoc",
        folderId,
        versionId: ""
      };
      return { params, multiple: true, showPanel: true, once: false };
    },
    isShowUploaderFile() {
      let data = this.currentNode;
      data = data || {};
      return data.fileNew ? data.fileNew === 1 : false;
    },

    isShowUploaderFolder() {
      let data = this.currentNode;
      data = data || {};
      return data.folderNew ? data.folderNew === 1 : false;
    },
    searchTiTle() {
      let data = this.currentNode;
      data = data || {};
      const { folderName } = data;
      return folderName ? `搜索"${folderName}"` : "";
    }
  },
  watch: {
    searchValue(newValue, oldValue) {
      clearTimeout(this.timeID);
      if (newValue) {
        this.timeID = setTimeout(() => {
          console.log("开始搜索啦");
          this.search();
        }, 500);
      } else {
        this.refresh();
      }
    }
  },
  methods: {
    // 移动到
    moveFile(val) {
      const a = disablePrompt();
      if (a) {
        if (this.selectArr.length === 0) {
          this.$message.warning("请选择至少一条数据");
        } else {
          this.$store.dispatch("perFileMoveAndCopy", true);
          this.$store.dispatch("perFileTitle", val);
        }
      }
    },
    // 复制到
    copyFile(val) {
      const a = disablePrompt();
      if (a) {
        if (this.selectArr.length === 0) {
          this.$message.warning("请选择至少一条数据");
        } else {
          this.$store.dispatch("perFileMoveAndCopy", true);
          this.$store.dispatch("perFileTitle", val);
        }
      }
    },
    // 新建文件夹
    addFolder() {
      const a = disablePrompt();
      if (a) {
        const { folderId } = this.currentNode;
        this.$prompt("", "新建文件夹", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入文件夹名称",
          inputPattern: /^\S*$/,
          inputErrorMessage: "文件夹名称不能包含空格",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          inputValidator: (value) => {
            if (!value) {
              return "文件夹名称不能为空";
            }
            if (value.length > 80) {
              return "文件夹名称不能大于80个字符";
            }
            var regExp = new RegExp('[\\\\|/:*<>?"]');
            if (regExp.test(value)) {
              return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
            }
            this.val = value;
          },
          beforeClose: async (action, instance, done) => {
            if (action === "confirm") {
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: true,
                message: "新建中..."
              });
              const enterpriseId = this.enterpriseId;
              const parentId = folderId;
              const folderName = this.val.replace(/\s*/g, "");
              const data = { parentId, folderName, enterpriseId };
              try {
                const result = await docService.queryenterpriseAddFolder(data);
                if (result.result === "0") {
                  await this.$store.dispatch("perFileUpdateNodeList");
                  this.$store.dispatch("perFileUpdateMessageObj", {
                    isShow: false
                  });
                  this.$message.success("新建成功");
                  this.$emit("pf");
                  done();
                }
              } catch (e) {
                this.$store.dispatch("perFileUpdateMessageObj", {
                  isShow: false
                });
              }
            } else {
              done();
            }
          }
        }).catch(() => {});
      }
    },
    // 分享
    batchShare() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      this.$store.dispatch("XtDesignIsShowShare");
    },
    async dropFileHandler(files, cb) {
      const opts = this.uploaderOpts;
      if (this.uploadMydoc && disablePrompt()) {
        await cb(files, opts);
        this.refresh();
      }
    },
    // uploadMydoc
    // 上传文件 文件夹
    async isFileOrFolder(type) {
      const a = disablePrompt();
      if (a) {
        const opts = this.uploaderOpts;
        await uploader.open({ ...opts, isDirectory: type !== "file" });
        this.refresh();
      }
    },
    // 删除功能
    async batchDel() {
      const a = disablePrompt();
      if (a) {
        const batchArr = this.selectArr;
        if (batchArr.length === 0) {
          return this.$message.warning("请选择文件");
        }
        const newData = this.selectArr.map((item) => item.folderId);
        try {
          this.$confirm("确定删除吗?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: true,
                message: "删除中..."
              });
              const result = await docService.queryDeleteFile(newData);
              if (result.result === "0") {
                await this.$store.dispatch("perFileDelListRow", newData);
                this.$store.dispatch("perFileUpdateMessageObj", {
                  isShow: false,
                  message: ""
                });
                this.$message({ type: "success", message: "删除成功" });
                this.$emit("pf");
              }
            })
            .catch(() => {});
        } catch (e) {
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      }
    },
    // 下载1
    batchDownload() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      const isFolder = batchArr.some((item) => item.isFolder === 1);
      if (isFolder) {
        return this.$message({
          type: "warning",
          message: "文件夹不支持批量下载"
        });
      } else if (batchArr.length > 10) {
        return this.$message.warning("一次批量下载最多选择10个文件");
      } else {
        const prjId = "EnterpriseDoc";
        const urls = batchArr.map((item) => {
          return downloadUrltoken(prjId, item.folderId, item.fileVersion);
        });
        for (let i = 0; i < urls.length; i++) {
          downloadFile(urls[i]);
        }
      }
    },
    refresh() {
      console.log("kkk");
      this.$emit("pf4", "");
      this.$store.dispatch("perShareCol", false);
      let data = this.currentNode;
      data = data || {};
      const { folderId } = data;
      if (folderId) {
        this.$store.dispatch("perFileUploadSucceedCB", folderId);
      }
    },
    search() {
      const keyWord = this.searchValue.replace(/\s*/g, "");
      const { folderId } = this.currentNode;
      const prjId = "EnterpriseDoc";
      const enterpriseId = this.enterpriseId;
      const searchObj = { prjId, folderId, keyWord, enterpriseId };
      this.$emit("pf4", searchObj);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#operationsContainer {
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: var(--middle-space) var(--big-space);
  box-sizing: border-box;

  .btnBgColor {
    margin-right: var(--small-space);
  }
}
</style>
